module.exports = __webpack_public_path__ + "img/cafe_pc_03.291e1c4a.png";